import { InternalService } from '../../core/services';
import { StoreStateType } from '@clientos/types';
import * as T from './types';

export default abstract class BaseStoreService extends InternalService {
  protected _state: StoreStateType;
  protected _observers: T.StoreObserverMapType;
  protected _internalObservers: T.StoreObserverMapType;
  protected _lastGeneratedId: number;

  constructor() {
    super();
    this._state = {};
    this._observers = new Map();
    this._internalObservers = new Map();
    this._lastGeneratedId = 0;
  }

  public get state(): StoreStateType {
    return this._state;
  }

  abstract setState(
    data: T.StoreSetStateDataType,
    options?: T.StoreSetStateOptionsType
  ): void;

  abstract dangerousSetState(data: T.StoreSetStateDataType): void;

  abstract addObserver(id: string, callback: T.StoreObserverCallbackType): void;

  abstract removeObserver(id: string): void;

  abstract generateId(): string;

  abstract useReactStore(React: any): any;

  protected _notifyObservers(previousState: StoreStateType): void {
    this._observers.forEach((callback) =>
      callback?.(this._state, previousState)
    );
    this._internalObservers.forEach((callback) =>
      callback?.(this._state, previousState)
    );
  }
}
